import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted } from "vue";
import { useForm } from "vee-validate";
import { useErrors } from "@/ts/utils/api-functions";
import * as Yup from "yup";
import FormInput from "@/ts/components/form/input.vue";
import FormFile from "@/ts/components/form/file.vue";
import Submit from "@/ts/components/form/submit.vue";
import axios from "axios";
import { checkIfFilesAreTooBig } from "@/ts/utils/file-validation";
import { useReCaptcha } from "vue-recaptcha-v3";

interface Props {
    subject?: string;
    class?: string;
}


export default /*#__PURE__*/_defineComponent({
  props: {
    subject: { type: String, required: false },
    class: { type: String, required: false }
  },
  setup(__props: any, { expose }) {
  expose();

const props = __props as {
    subject?: string;
    class?: string;
}

const apiErrors = useErrors();
const success = ref(false);
const loading = ref(false);
const height = ref(0);
const component = ref<HTMLDivElement>();
const reCaptcha = useReCaptcha();



const { handleSubmit, isSubmitting } = useForm({
    initialValues: {
        first_name: "",
        last_name: "",
        email: "",
        phone: "",
        comment: "",
        subject: props.subject && props.subject != "" ? props.subject : "Nieuw bericht",
        files: [],
    },
    validationSchema: Yup.object({
        subject: Yup.string().required().label("Onderwerp"),
        first_name: Yup.string().required().label("Voornaam"),
        last_name: Yup.string().required().label("Achternaam"),
        email: Yup.string().email().required().label("E-mailadres"),
        phone: Yup.string()
            .matches(/(((\+|00)3[12][ ]?(?:\(0\)[ ]?)?)|0){1}(4(60|[789]\d)\/?(\s?\d{2}\.?){2}(\s?\d{2})|(\d\/?\s?\d{3}|\d{2}\/?\s?\d{2})(\.?\s?\d{2}){2})/, "Telefoonnummer is ongeldig")
            .required()
            .label("Telefoonnummer"),
        comment: Yup.string().required().label("Bericht"),
        files: Yup.array().test("is-big-file", "Totale bestandsgrootte mag maximum 10MB zijn", checkIfFilesAreTooBig),
    }),
});

const onSubmit = handleSubmit(async (values, { resetForm }) => {
    loading.value = true;
    try {
        await reCaptcha!.recaptchaLoaded();
        const token = await reCaptcha!.executeRecaptcha("login");
        //formData.append("g-recaptcha-response", token);
        await axios.post("/api/contact", values);
        success.value = true;
        height.value = 0;
        setTimeout(() => {
            resetForm();
        }, 500);
    } catch (error) {
        apiErrors.parse(error);
    } finally {
        loading.value = false;
    }
});

onMounted(() => {
    height.value = component.value!.offsetHeight;
});

const __returned__ = { apiErrors, success, loading, height, component, reCaptcha, props, handleSubmit, isSubmitting, onSubmit, FormInput, FormFile, Submit }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})